/* src/app/features/tranches/modal-confirma-fator-ecg/modal-confirma-fator-ecg.scss */
.alert {
  margin-top: 1em !important;
}
/*# sourceMappingURL=modal-confirma-fator-ecg.css.map */
